<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form class="multi-col-validation mt-6" ref="form">
        <v-row>
          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="firstName"
              label="Имя"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="lastName"
              label="Фамилия"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="patronymic"
              label="Отчество"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="email"
              label="Почта"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="phoneNumber"
              label="Телефонный номер"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <date-picker
              v-model="birthDate"
              label="День рождения"
            ></date-picker>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click.prevent="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click.prevent="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import DatePicker from '@/components/date-picker'
import { mapFormHandlers } from '@/helpers/forms'
import { mapActions } from 'vuex'

export default {
  name: 'AccountSettingsAccount',
  components: {
    DatePicker,
  },
  computed: {
    ...mapFormHandlers('user/form', [
      'email',
      'phoneNumber',
      'firstName',
      'lastName',
      'patronymic',
      'birthDate',
    ]),
  },
  methods: {
    cancel() {
      this.resetForm()
      this.$router.back()
    },
    ...mapActions('user/form', ['resetForm', 'update']),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update()
        this.resetForm()
      }
    },
  },
}
</script>
